import { Button, Grid } from '@material-ui/core'
import React, { useState } from 'react'

const SidebarApplicants = () => {

    const [closeClicked, setcloseClicked] = useState(false)

    return (
        <Grid xs={12} className={`LeftMenuCol ${closeClicked ? "CloseMenu" : "OpenMenu"}`}>
            <Grid className="BrandLogo">
            </Grid>
            <Button className="MenuCloseBtn" onClick={() => setcloseClicked(true)} />
        </Grid>
    )
}

export default SidebarApplicants